import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ReactPaginate from 'react-paginate';
import Postman from '../utils/service';
import { withRouter, Link } from 'react-router-dom';
import LinkedinIcon from 'react-share/lib/LinkedinIcon';
import { encodeforspace, amountFormatter, showEzoicAds } from '../utils/helper';
import EnhancedTableHead from './tableHead';
import { Helmet } from 'react-helmet';
import { cutString } from '../utils/helper'
// import { GooglePublisherTags } from '../views/GooglePublisherTags';
import LazyLoad from 'react-lazyload'
// import AdSense from 'react-adsense';
import { Row, Col } from 'reactstrap';
import ReactTooltip from "react-tooltip";
import Cookies from 'js-cookie';
import AdSense from 'react-adsense';

const ReactMarkdown = require('react-markdown')
const env = process.env.NODE_ENV || 'development';
const config = require('../config.json')[env];
const admin_url = config.admin_url;

const rows = [
  { id: 'stateRanking', numeric: true, disablePadding: false, label: 'Rank' },
  { id: 'company_name', numeric: false, disablePadding: false, label: 'Company' },
  { id: 'city', numeric: true, disablePadding: false, label: 'City' },
  { id: 'state', numeric: true, disablePadding: false, label: 'State' },
  // { id: 'country', numeric: true, disablePadding: false, label: 'Country' },
  { id: 'total_funding_float', numeric: true, disablePadding: false, label: 'Funding' },
  { id: 'Industry', numeric: true, disablePadding: false, label: 'Industry' },
  { id: 'current_employees', numeric: true, disablePadding: false, label: 'Employees' },
  { id: 'estimated_revenues', numeric: true, disablePadding: false, label: 'Revenue' },
  { id: 'Points', numeric: true, disablePadding: false, label: 'Predictive Score' },
  { id: 'Name', numeric: true, disablePadding: false, label: 'Person Name' },
  { id: 'Title', numeric: true, disablePadding: false, label: 'Title' },
  { id: 'Email/Phone', numeric: true, disablePadding: false, label: 'Phone/Email' },


];

const styles = theme => ({
  root: {
    width: '100%',
    //height: 645,
    // marginTop: theme.spacing.unit * 1,
    // marginBottom: 20,
    overflowX: 'auto'
  },
  table: {
    minWidth: 820,
    height: 500,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
});


class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);

    const statePage = props.data.statePage == undefined ? [] : props.data.statePage
    const tableData = props.data.tableData == undefined ? [] : props.data.tableData.data
    const pageCount = props.data.tableData == undefined ? 0 : props.data.tableData.totalCount / 100

    this.state = {
      order: 'asc',
      orderBy: 'stateRanking',
      offset: 0,
      selected: [],
      data: [],
      page: 0,
      rowsPerPage: 100,
      tableData: tableData,
      pageCount: pageCount,
      state: null,
      country: null,
      _page: 0,
      showAd: false,
      statePage: statePage,
      isLoggedIn: Cookies.get('token') || Cookies.get('accessToken') ? true : false,
      showAlertRevealPhone: false,
      empContacts: []

    };
    this.flag = false;
    //this.getData();
  }

  getPhoneEmail = (id) => {
    if(!this.state.isLoggedIn) 
      return this.props.history.push('/join');
    Postman.getEmployeePhoneEmail(id)
      .then(res => {
        if (res.data.emp && res.data.emp.id) {
          this.setState({ empContacts: { ...this.state.empContacts, [id]: res.data.emp } })
        } else {
          this.setState({ showAlertRevealPhone: true })
        }
      })
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy }, () => this.getData());

  };
  handleClick = (event, company, id) => {

    event.stopPropagation()
    this.props.history.push(`/company/${encodeforspace(company)}`);
  }


  isSelected = id => this.state.selected.indexOf(id) !== -1;

  getData = () => {
    console.log('this.state')
    const { order, orderBy, offset, rowsPerPage, state } = this.state

    Postman.getCompaniesByState(order, orderBy, offset, rowsPerPage, state)
      .then(res => {
        this.setState({ tableData: res.data.data, pageCount: res.data.totalCount / rowsPerPage })
        showEzoicAds([122, 123, 124]);
        this.setState({ showAd: false })
        setTimeout(() => {
          this.setState({ showAd: true })
        }, 1000)
      })

    fetch(`${admin_url}/statepages?State=${state}`)
      .then(response => response.json())
      .then(res => {
        if (res.length > 0)
          this.setState({ statePage: res[0] })
      })

  }

  componentDidMount() {
    this.setState({ showAd: true })
  }


  componentWillReceiveProps(nextProps) {
    console.log('nextProps', nextProps)
    // this.setState({ showAd: false })
    // setTimeout(() => {
    //   this.setState({ showAd: true })
    // }, 1000)
    if (nextProps.cityPageData != this.state.statePage) {
      this.setState({ cityPage: nextProps.cityPageData })
    }
    if (offset == this.state.offset && nextProps.city == this.state.city) {
      return false
    }
    var page = nextProps.match.params.page || 1
    const offset = (page - 1) * this.state.rowsPerPage
    var { state } = nextProps.match.params
    this.setState({ state, offset }, () => this.getData())

  }

  handlePageClick = ({ selected }, state) => {
    if (!isNaN(selected)) {
      if (selected > 0) this.props.history.push(`/state/${state}/${selected + 1}`)
      if (selected == 0) this.props.history.push(`/state/${state}`)
    }

    const offset = 0
    this.setState({ offset }, () => { if (offset > 0) { this.getData() } })
  }
  render() {
    const { classes } = this.props;
    const { data, order, orderBy, selected, rowsPerPage, tableData, pageCount, statePage } = this.state;
    const state = this.props.match.params.state;
    //TODO list
    const emptyRows = rowsPerPage - tableData.length;
    const page = this.props.match.params.page || 1
    const nextPage = parseInt(page) + 1
    const exportLink = this.state.isLoggedIn ? '/export_list' : '/join'

    // {/* {(page==2)&&<link rel="prev" href={`https://growjo.com/state/${state}`} />}
    // {(page>2)&&<link rel="prev" href={`https://growjo.com/state/${state}/${page-1}`} />}
    // {(page<pageCount)&&<link rel="next" href={`https://growjo.com/state/${state}/${nextPage}`} />} */}

    return (
      <div>
        <Helmet>
          <link rel="canonical" href={`https://growjo.com/state/${state}`} />
        </Helmet>
        {statePage.Description && <Row style={{ marginLeft: 30, marginBottom: 15 }}>
          <div style={{ marginTop: 20 }}>
            <ReactMarkdown source={statePage.Description} />
          </div>
        </Row>}
        <div className='row test' style={{ marginRight: 20, marginBottom: 15, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <div style={{ color: "#20a8d8", cursor: "pointer" }}>
            <Link className='exportBtn' key={'export_list'} to={exportLink}><i className='fa fa-arrow-circle-up '></i>Export List</Link>
          </div>
        </div>
        <Paper className={classes.root}>
          <div style={{ overflowX: 'auto' }}>
            <Table aria-labelledby="tableTitle" style={{ minWidth: 820, height: 500, tableLayout: 'fixed', whiteSpace: 'nowrap' }}>
              <colgroup>
                <col style={{ width: '3%' }} />
                <col style={{ width: '13%' }} />
                <col style={{ width: '5%' }} />
                <col style={{ width: '4%' }} />
                <col style={{ width: '5%' }} />
                <col style={{ width: '5%' }} />
                <col style={{ width: '5%' }} />
                <col style={{ width: '5%' }} />
                <col style={{ width: '6%' }} />
                <col style={{ width: '9%' }} />
                <col style={{ width: '7%' }} />
                <col style={{ width: '12%' }} />
              </colgroup>
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
                rowCount={data.length}
                rows={rows}
              />
              <TableBody>
                {tableData.map((n, index) => {
                  let AD = ''
                  if (index == 25) {
                    AD = (
                      // <div id="ezoic-pub-ad-placeholder-122"> </div>
                      <AdSense.Google
                        client='ca-pub-1304487994033637'
                        slot='2572498222'
                        style={{ display: "block" }}
                        responsive='true'
                        format="auto"
                      />
                    )
                  } else if (index == 50) {
                    AD = (
                      <AdSense.Google
                        client='ca-pub-1304487994033637'
                        slot='1471794262'
                        style={{ display: "block" }}
                        responsive='true'
                        format="auto"
                      />
                      // <div id="ezoic-pub-ad-placeholder-123"> </div>
                    )
                  } else if (index == 75) {
                    AD = (
                      // <div id="ezoic-pub-ad-placeholder-124"> </div>
                      <AdSense.Google
                        client='ca-pub-1304487994033637'
                        slot='5411039276'
                        style={{ display: "block" }}
                        responsive='true'
                        format="auto"
                      />
                    )
                  }
                  const isSelected = this.isSelected(n.id);
                  if (n.country === 'United States') n.country = 'USA';
                  let empPhoneEmail = null
                  if(n.employeeData){
                    let empId = n.employeeData.id
                    empPhoneEmail = (<button style={{ borderRadius: "7px" }} className='btn btn-primary' onClick={() => this.getPhoneEmail(empId)}>Reveal Email/Phone</button>)

                    let empEmail = n.employeeData.email;
                    let empPhone = n.employeeData.phone;
  
                    if (this.state.empContacts[empId]) {
                      empEmail = this.state.empContacts[empId].email;
                      empPhone = this.state.empContacts[empId].phone;
                    }
  
                    if (empEmail || empEmail) {
                      empPhoneEmail = (
                        <React.Fragment>
                          <a href={`mailto:${empEmail}`}>{empEmail}</a>
                          <i style={{ paddingLeft: '5px', cursor: 'pointer' }} className="fa fa-copy" onClick={() => { navigator.clipboard.writeText(empEmail) }}></i>
                          <br />
                          {empPhone}
                        </React.Fragment>)
                    }
                  }

                  


                  return (
                    <React.Fragment key={'state_' + index}>
                      {this.state.showAd && AD != '' && <TableRow >
                        <TableCell
                          className="text-center"
                          colSpan={9}
                        >
                          {AD}
                        </TableCell>
                      </TableRow>}
                      <TableRow
                        hover
                        //onClick={event => this.handleClick(event, n.company_name, n.id)}
                        role="checkbox"
                        aria-checked={isSelected}
                        tabIndex={-1}
                        key={n.id}
                        selected={isSelected}
                      >
                        <TableCell align="center" style={{ backgroundColor: 'white', padding: 0 }}>{n.stateRanking || 'N/A'}</TableCell>
                        <TableCell align="left">
                          <LazyLoad>
                            <a href={`//${n.url}`} target="_blank" onClick={(e) => { e.stopPropagation() }} style={{ marginRight: 5, fontSize: 15, color: '#13135c', textDecoration: "none" }}>
                              <img src={`https://www.google.com/s2/favicons?domain=${n.url}`} style={{ marginRight: 5, width: 18 }} />
                            </a>
                          </LazyLoad>
                          <Link key={n.id} to={`/company/${encodeforspace(n.company_name)}`} style={{ marginRight: 5, fontSize: 15 }}>{cutString(n.company_name, 15)}</Link>
                          <LazyLoad>
                            <div style={{ display: 'inline-block', marginLeft: 8 }}>
                              <a href={n.linkedin_url} target="_blank" onClick={(e) => { e.stopPropagation() }}>
                                <LinkedinIcon size={15} />
                              </a>
                            </div>
                          </LazyLoad>
                        </TableCell>
                        <TableCell align="left">{cutString(n.city, 10)}</TableCell>
                        <TableCell align="left">{n.state}</TableCell>
                        {/* <TableCell align="left">{n.country}</TableCell> */}
                        <TableCell align="left">{n.total_funding}</TableCell>
                        <TableCell align="left">
                          <Link className='custom-anchor' key={n.id} to={`/industry/${encodeURIComponent(n.Industry)}`}>{cutString(n.Industry, 14)}</Link>

                        </TableCell>
                        <TableCell align="left" style={{ paddingLeft: 40 }}>
                          <span className="tooltip-icon">
                            <a
                              data-for="custom-class"
                              data-tip="<b>Source: Growjo</b><p>To license the growjo Dataset  
                                  <a target='_new' href='https://growjo.com/schedule-demo'> click here</a></p>"
                              data-html={true}>
                              {n.current_employees}
                            </a>
                            <ReactTooltip
                              id="custom-class"
                              className="extraClass"
                              delayHide={1000}
                              effect="solid"
                            />
                          </span>
                        </TableCell>
                        <TableCell align="left">${amountFormatter(n.estimated_revenues, 1)}</TableCell>

                        <TableCell align="left"><strong style={{ marginLeft: 15, color: 'green', fontSize: 15 }}>{n.Points}</strong></TableCell>
                        <TableCell align="left">
                          {n.employeeData &&
                            <Link key={n.employeeData.id} to={`/employee/` + encodeforspace(n.employeeData.first_name + '-' + n.employeeData.last_name) + '-' + n.employeeData.id} style={{ marginRight: 5, fontSize: 15, textDecoration: 'none' }}>
                              {cutString(n.employeeData.first_name + ' ' + n.employeeData.last_name, 15)}
                            </Link>
                          }

                          {!n.employeeData && '-'}

                        </TableCell>

                        <TableCell align="left">{n.employeeData ? cutString(n.employeeData.title, 10) : '-'}</TableCell>
                        <TableCell align="left">
                          {n.employeeData && empPhoneEmail}
                          {!n.employeeData && '-'}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
                {/* {emptyRows > 0 && (
                <TableRow style={{ height: 49 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )} */}
              </TableBody>
            </Table>
          </div>
        </Paper>
        <div style={{ float: "right", marginTop: 25 }}>
          <ReactPaginate
            previousLabel={'<<'}
            nextLabel={'>>'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={(e) => this.handlePageClick(e, state)}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            initialPage={this.props.match.params.page - 1}
            hrefBuilder={(page) => page == 1 ? `/state/${state}` : `/state/${state}/${page}`}
          />
        </div>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(EnhancedTable));


// WEBPACK FOOTER //
// ./client/src/components/dataTableState.js